import { render, staticRenderFns } from "./rmAkcd.vue?vue&type=template&id=769e6424"
import script from "./rmAkcd.vue?vue&type=script&lang=js"
export * from "./rmAkcd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports